import { UPDATE_TYPES } from './dpc-form.vue';
import mergeWith from 'lodash/mergeWith';
import reduce from 'lodash/reduce';
import uniq from 'lodash/uniq';
import isArray from 'lodash/isArray';
import invert from 'lodash/invert';
import merge from 'lodash/merge';
import mapValues from 'lodash/mapValues';
import map from 'lodash/map';

export const InputIdProvider = {
  inject: {
    formContext: {
      default() {
        return () => {
          // fail silently, if not inside form
        };
      },
    },
  },
  data() {
    return {
      uuid: this.$uuid.v1(),
    };
  },
  computed: {
    id() {
      const uuid = this.formContext.uuid ? `${this.formContext.uuid}-` : '';
      const name = this.name || this.uuid;
      return `input-${uuid}${name}`; // input prefix, because uuid and name could start with a number, which would be invalid
    },
  },
};

function concatenateArrays(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}

export const FieldUpdateProvider = ({ baseClass }) => ({
  inject: {
    getFieldUpdatesByName: {
      default() {
        return () => [
          // fail silently, if not inside form
        ];
      },
    },
  },
  computed: {
    _fieldUpdateList() {
      return this.getFieldUpdatesByName(this.name);
    },
    $fieldUpdateBinding() {
      return merge(this._fieldUpdateAttributeList, {
        class: [
          ...this._fieldUpdateModifierClassList,
          ...this._fieldUpdateClassList,
        ],
      });
    },
    _fieldUpdateAttributeList() {
      const updateList = this._fieldUpdateList[UPDATE_TYPES.attribute] || {};

      const updateValueList = map(updateList, update => update.value);

      const updateValueListByAttribute = reduce(
        updateValueList,
        (result, updateValue) => {
          result = mergeWith(result, updateValue, concatenateArrays);
          return result;
        },
        {}
      );

      const seperatedBySpace = mapValues(updateValueListByAttribute, value => {
        return value.join(' ');
      });

      return seperatedBySpace;
    },
    _fieldUpdateModifierClassList() {
      const updateList =
        this._fieldUpdateList[UPDATE_TYPES.modifierClass] || [];

      const keyedClassList = uniq(
        map(updateList, update => `${baseClass}${update.value}`)
      );

      const classList = Object.values(keyedClassList);

      return classList;
    },
    _fieldUpdateClassList() {
      const updateList = this._fieldUpdateList[UPDATE_TYPES.class] || [];

      const keyedClassList = uniq(map(updateList, update => update.value));

      const classList = Object.values(keyedClassList);

      return classList;
    },
  },
  methods: {
    $makeFieldUpdateBinding({ classListObject = {} }) {
      return {
        ...this.$fieldUpdateBinding,
        class: [...this.$fieldUpdateBinding.class, classListObject],
      };
    },
  },
});
